<template>
    <div>
        <OcorrenciaInfo :idOcorrencia="idOcorrencia" @setActionCard="setActionCard" :isFinalizado="ocorrencia.flFinalizado" />

        <div class="row" v-if="ocorrencia.idChamado > 0">
            <div class="col-12">
                <label class="form-label" style="color: #AB0000"> Chamado</label>
                <Card_Title :class_color="'bg-color-4'">
                    <template v-slot:context>
                        <div class="row">

                            <div class="col-8">
                                <label class="form-label"> Nº do Chamado</label>
                                <h5 class="card-dados">
                                    {{ ocorrencia.idChamado }}
                                </h5>
                            </div>
                            <div class="col">
                                <label class="form-label"> Status do Chamado</label>
                                <h5 class="card-dados">{{ chamado.nmStatus }}</h5>
                            </div>
                        </div>
                    </template>
                </Card_Title>
            </div>
        </div>

        <div class="row">
            <div class="mt-2 col-12" v-if="inadimplente != '' && inadimplente != 'ATIVO' && inadimplente != 'PERDA'">
                <div class="alert alert-danger" role="alert" v-if="inadimplente == 'INADIMPLENTE_PRODUTO'">
                    <i class="fas fa-exclamation-triangle"></i><span class="txt-alert-pendencia" style="margin-left: 5px !important;">COM PENDÊNCIAS FINANCEIRAS NO PRODUTO !</span>
                </div>
                <div class="alert alert-danger" role="alert" v-else-if="inadimplente == 'INADIMPLENTE_GRUPO'">
                    <i class="fas fa-exclamation-triangle"></i><span class="txt-alert-pendencia" style="margin-left: 5px !important;">COM PENDÊNCIAS FINANCEIRAS NO GRUPO !</span>
                </div>
            </div>


            <div :class="(ocorrencia.idPessoa > 0 ? 'col-6 ' : 'col-12')" v-if="ocorrencia.idInstituicao > 0">
                <label class="form-label" style="color: #AB0000"> Unidade de Compra</label>
                <Card_Title :class_color="'bg-color-4'">
                    <template v-slot:context>
                        <div class="row">
                            <div class="col-8">
                                <label class="form-label"> Razão Social</label>
                                <h5 class="card-dados">
                                    {{ dados.nmUf }} | {{ dados.cdInstituicao }} | {{ dados.nmRazaoSocial }}
                                </h5>
                            </div>
                            <div class="col">
                                <label class="form-label" style="color: #AB0000">Cnpj</label>
                                <h5 class="card-dados">
                                    {{ dados.nrCnpj }}
                                </h5>
                            </div>
                            <div class="col-2">
                                <label class="form-label">Tipo</label>
                                <h5 class="card-dados">
                                    {{ dados.dsTipoInstituicao }}
                                </h5>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <label class="form-label"> E-mail</label>
                                <h5 class="card-dados">{{ dados.dsEmailInstituicao }}</h5>
                            </div>
                            <div class="col">
                                <label class="form-label"> Telefone ou Celular</label>
                                <h5 class="card-dados">{{ dados.nrTelefoneInstituicao }}</h5>
                            </div>
                            <div class="col-2">
                                <label class="form-label">Score</label>
                                <h5 class="card-dados">
                                    <span class="ms-auto d-flex">
                                        <i v-for="index in 6" :key="index" :class="index <= dados.nrNotaCliente ? 'fas fa-star' : 'far fa-star'" class="star-avaliacao"></i>
                                    </span>
                                </h5>
                            </div>
                        </div>
                    </template>
                </Card_Title>
            </div>

            <div class="col-6" v-if="ocorrencia.idPessoa > 0">
                <label class="form-label" style="color: #AB0000"> Pessoa</label>
                <Card_Title :class_color="'bg-color-4'">
                    <template v-slot:context>

                        <div class="row">
                            <div class="col-12 row">
                                <label class="form-label col-2" style="color: #BBBBBB"> Identificação</label>
                                <div class="col-10 card-idt">
                                </div>
                            </div>
                            <div class="col-9">
                                <label class="form-label"> Nome</label>
                                <h5 class="card-dados">{{ dados.nmPessoa }}</h5>
                            </div>
                            <div class="col">
                                <label class="form-label"> CPF</label>
                                <!--<h5 class="card-dados">{{ dados.nrCpf }}</h5>-->
                                <h5 class="card-dados">***.***.***-**</h5>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 row">
                                <label class="form-label col-2" style="color: #BBBBBB;"> Contato</label>
                                <div class="col-10 card-cont">
                                </div>
                            </div>
                            <div class="col-6">
                                <label class="form-label"> E-mail</label>
                                <h5 class="card-dados">{{ dados.dsEmail }}</h5>
                            </div>
                            <div class="col">
                                <label class="form-label"> Telefone</label>
                                <h5 class="card-dados">{{ dados.nrTelefonePessoa }}</h5>
                            </div>
                            <div class="col">
                                <label class="form-label"> Celular</label>
                                <h5 class="card-dados">{{ dados.nrCelular }}</h5>
                            </div>
                        </div>
                    </template>
                </Card_Title>

            </div>

        </div>

        <div class="row mt-1">
            <div class="col-12">
                <div class="row dados-ticket-gerais">

                    <div class="col" style="border-right: 1px solid #bbbbbb;">
                        <DataTable :url_ajax="getUrlEventosInstituicao()" :ajax_set_result="setTable"
                                   @grid_refreshed="gridRefreshed" :refresh="refresh_grid_EventosInstituicao" :filtros="filtro"
                                   method="GET" :qtd_registros_por_pagina="20" :is_table="true" :footer_fixed="false"
                                   customHeight="margin-top: 0px !important;max-height: calc(100vh - 33.5rem);"
                                   :headers="headersEventosInstituicao" :pBtnsSlot="true"
                                   :borderColor="getBackgroundColor(cdSetorClassificacaoEtapa)" :request_api="'comercial'">
                        </DataTable>
                    </div>

                    <div class="col" style="border-right: 1px solid #bbbbbb;">
                        <DataTable :url_ajax="getUrlEventosInstituicaoAno()" :ajax_set_result="setTable"
                                   @grid_refreshed="gridRefreshed" :refresh="refresh_grid_EventosInstituicaoAno" :filtros="filtro"
                                   method="GET" :qtd_registros_por_pagina="20" :is_table="true" :footer_fixed="false"
                                   customHeight="margin-top: 0px !important;max-height: calc(100vh - 33.5rem);"
                                   :headers="headersEventosInstituicaoAno" :pBtnsSlot="true"
                                   :borderColor="getBackgroundColor(cdSetorClassificacaoEtapa)" :request_api="'comercial'">
                        </DataTable>
                    </div>



                    <div class="col" style="border-right: 1px solid #bbbbbb;">
                        <DataTable :url_ajax="getUrlProdutosInstituicao()" :ajax_set_result="setTable"
                                   @grid_refreshed="gridRefreshed" :refresh="refresh_grid_ProdutosInstituicao" :filtros="filtro"
                                   method="GET" :qtd_registros_por_pagina="20" :is_table="true" :footer_fixed="false"
                                   customHeight="margin-top: 0px !important;max-height: calc(100vh - 33.5rem);"
                                   :headers="headersProdutosInstituicao" :pBtnsSlot="true"
                                   :borderColor="getBackgroundColor(cdSetorClassificacaoEtapa)" :request_api="'comercial'">
                            <template v-slot:BtnSlot="">

                            </template>
                        </DataTable>
                    </div>
                    <div class="col" style="border-right: 1px solid #bbbbbb;" v-if="ocorrencia.idPessoa > 0">
                        <DataTable :url_ajax="getUrlEventosPessoa()" :ajax_set_result="setTable"
                                   @grid_refreshed="gridRefreshed" :refresh="refresh_grid_EventosPessoa" :filtros="filtro"
                                   method="GET" :qtd_registros_por_pagina="20" :is_table="true" :footer_fixed="false"
                                   customHeight="margin-top: 0px !important;max-height: calc(100vh - 33.5rem);"
                                   :headers="headersEventosPessoa" :pBtnsSlot="true"
                                   :borderColor="getBackgroundColor(cdSetorClassificacaoEtapa)" :request_api="'comercial'">
                            <template v-slot:BtnSlot="">

                            </template>
                        </DataTable>
                    </div>
                    <div class="col" v-if="ocorrencia.idPessoa > 0">
                        <DataTable :url_ajax="getUrlProdutosPessoa()" :ajax_set_result="setTable"
                                   @grid_refreshed="gridRefreshed" :refresh="refresh_grid_ProdutosPessoa" :filtros="filtro"
                                   method="GET" :qtd_registros_por_pagina="20" :is_table="true" :footer_fixed="false"
                                   customHeight="margin-top: 0px !important;max-height: calc(100vh - 33.5rem);"
                                   :headers="headersProdutosPessoa" :pBtnsSlot="true"
                                   :borderColor="getBackgroundColor(cdSetorClassificacaoEtapa)" :request_api="'comercial'">
                            <template v-slot:BtnSlot="">

                            </template>
                        </DataTable>
                    </div>
                </div>

            </div>

            <div class="col">

            </div>
        </div>

        <div class="row mt-3">
            <div class="col" v-if="ocorrencia.idInstituicao > 0">
                <div class="row">

                    <div class="col">
                        <div :class="'card mt-1 p-0 mb-2 shadow-v2'" style="border-radius: 5px 5px 90px 5px;">
                            <div class="row g-0 box-info">
                                <div class="card-body" v-if="ocorrencia.idEvento <= 0">
                                    <div class="row">
                                        <div class="col-9">
                                            <p class="card-title">
                                                <span class="cart-title-span">Produto Ativo</span>
                                            </p>
                                            <p class="card-text"
                                               v-if="ocorrencia.idContrato != 0 && ocorrencia.idContrato != null">
                                                <span class="card-text-sim">Sim <i class="fas fa-check"></i></span>
                                            </p>
                                            <p class="card-text" v-else>
                                                <span class="card-text-nao">
                                                    Não <i class="fas fa-times btn-close-style"></i>
                                                </span>
                                            </p>
                                            <p class="card-text"
                                               v-if="ocorrencia.idContrato != 0 && ocorrencia.idContrato != null">
                                                <span style="margin-left: 5px;" class="text-muted">
                                                    Cliente a<span class="cart-title-span">
                                                        {{ dados.nrMesesCliente }}
                                                        meses
                                                    </span>
                                                </span>
                                            </p>
                                        </div>
                                        <div class="col">
                                            <span class="card-text-neutro"><i class="fas fa-check"></i></span>
                                            <span class="card-text-neutro">
                                                <i class="fas fa-times btn-close-style"></i>
                                            </span>
                                        </div>
                                    </div>

                                </div>
                                <div class="card-body" v-else>
                                    <div class="row">
                                        <div class="col-9">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col" v-if="ocorrencia.idInstituicao > 0">
                        <div :class="'card mt-1 p-0 mb-2 shadow-v2'" style="border-radius: 5px 5px 90px 5px;">
                            <div class="row g-0 box-info">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-9">
                                            <p class="card-title">
                                                <span class="cart-title-span">
                                                    Pessoas
                                                </span>
                                            </p>
                                            <p class="card-text">
                                                <span style="margin-left: 5px; font-size: 18px;">
                                                    Possui <span class="pessoa-ticket" style="">
                                                        {{ dados.pessoasInstituicao }}
                                                    </span>
                                                </span>
                                            </p>

                                            <button class="btn-grid-editar-lista-v2" type="button" v-on:click="openModalPessoas">
                                                <i class="fas fa-users"></i><span class="ms-1">Ver Pessoas</span>
                                            </button>

                                        </div>
                                        <div class="col">
                                            <span class="card-text-neutro"><i class="fab fa-usb"></i></span>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="col-6">
                <div class="row">
                    <div class="col" v-if="ocorrencia.idInstituicao > 0">
                        <div :class="'card mt-1 p-0 mb-2 shadow-v2'" style="border-radius: 5px 5px 90px 5px;">
                            <div class="row g-0 box-info">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-9">
                                            <p class="card-title">
                                                <span class="cart-title-span">NPS</span>
                                            </p>
                                            <br />
                                            <p class="card-text" v-if="dados.nrNps == null">
                                                <span style="margin-left: 5px; font-size: 16px;">
                                                    <span style="font-weight: bold;">Não avaliado</span>
                                                </span>
                                            </p>
                                            <p class="card-text" v-else>
                                                <span style="margin-left: 5px; font-size: 16px;" v-if="dados.nrNps < 7">
                                                    <span class="text-danger" style="font-weight: bold;">
                                                        Detrator ({{
                                                        dados.nrNps
                                                        }})
                                                    </span>
                                                </span>
                                                <span style="margin-left: 5px; font-size: 16px;"
                                                      v-else-if="dados.nrNps < 9">
                                                    <span class="text-warning" style="font-weight: bold;">
                                                        Neutro ({{
                                                        dados.nrNps
                                                        }})
                                                    </span>
                                                </span>
                                                <span style="margin-left: 5px; font-size: 16px;" v-else>
                                                    <span class="text-success" style="font-weight: bold;">
                                                        Promotor ({{
                                                        dados.nrNps
                                                        }})
                                                    </span>
                                                </span>
                                            </p>
                                        </div>
                                        <div class="col">
                                            <span class="card-text-neutro"><i class="fas fa-address-card"></i></span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col">
                        <div :class="'card mt-1 p-0 mb-2 shadow-v2'" style="border-radius: 5px 5px 90px 5px;">
                            <div class="row g-0 box-info">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-9">
                                            <p class="card-title">
                                                <span class="cart-title-span">CONSULTOR</span>
                                            </p>
                                            <br />
                                            <p class="card-text">
                                                <span style="margin-left: 5px; font-size: 16px;" v-if="dados.nmUsuario != null">
                                                    <span style="font-weight: bold;">{{ dados.nmUsuario }}</span>
                                                </span>
                                                <span style="margin-left: 5px; font-size: 16px;" v-else>
                                                    <span style="font-weight: bold;">Sem Consultor</span>
                                                </span>
                                            </p>
                                        </div>
                                        <div class="col">
                                            <span class="card-text-neutro"><i class="fas fa-address-card"></i></span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col" v-if="ocorrencia.idInstituicao <= 0">

                    </div>

                </div>
            </div>
        </div>

        <div class="row mt-3">

            <div class="col-6" v-if="dados.idContrato > 0">

                <label class="form-label" style="color: #AB0000"> Contrato</label>
                <Card_Title :class_color="'bg-color-4'">
                    <template v-slot:context>

                        <div class="row">

                            <div class="col">
                                <label class="form-label"> Ativo</label>
                                <h5 class="card-dados">
                                    {{ dados.flAtivo }}
                                </h5>
                            </div>
                            <div class="col">
                                <label class="form-label"> Nº Contrato</label>
                                <h5 class="card-dados">{{ dados.nrContrato }}/{{ dados.nrAno }}</h5>
                            </div>
                            <div class="col">
                                <label class="form-label"> Início Vigência</label>
                                <h5 class="card-dados">{{ dados.dtInicio }}</h5>
                            </div>
                            <div class="col">
                                <label class="form-label"> Fim Vigência</label>
                                <h5 class="card-dados">{{ dados.dtFim }}</h5>
                            </div>

                        </div>
                        <div class="col-11 card-line"></div>
                        <div class="row mt-3">

                            <div class="col">
                                <label class="form-label"> Plano</label>
                                <h5 class="card-dados">{{ dados.nmPlano }}</h5>
                            </div>
                            <div class="col">
                                <label class="form-label"> Qtd. Licenças</label>
                                <h5 class="card-dados">{{ dados.qtdLicencas }}</h5>
                            </div>
                            <div class="col">
                                <label class="form-label"> Qtd. Usuários</label>
                                <h5 class="card-dados" v-if="dados.qtdUsuarios == 0"> Ilimitado</h5>
                                <h5 class="card-dados" v-else>{{ dados.qtdUsuarios }}</h5>
                            </div>
                            <div class="col">
                                <label class="form-label"> Valor</label>
                                <h5 class="card-dados">R$ {{ formatPrice(dados.vlContrato) }}</h5>
                            </div>

                        </div>
                        <div class="col-11 card-line"></div>
                        <div class="row mt-3">

                            <div class="col">
                                <label class="form-label"> Modalidade</label>
                                <h5 class="card-dados" v-if="dados.tpModalidade == 'Pregão eletr'">Pregão eletrônico</h5>
                                <h5 class="card-dados" v-else-if="dados.tpModalidade == '' || dados.tpModalidade == null">
                                    Sem modalidade
                                </h5>
                                <h5 class="card-dados" v-else>{{ dados.tpModalidade }}</h5>
                            </div>
                            <div class="col">
                                <label class="form-label"> Índice de Correção</label>
                                <h5 class="card-dados" v-if="dados.nmContratoIndiceCorrecao != null">
                                    {{
                                    dados.nmContratoIndiceCorrecao
                                    }}
                                </h5>
                                <h5 class="card-dados" v-else>Sem Índice de reajuste!</h5>
                            </div>
                            <div class="col">
                                <label class="form-label"> Nº Contrato Cliente</label>
                                <h5 class="card-dados" v-if="dados.nrContratoCliente != null">
                                    {{ dados.nrContratoCliente }}
                                </h5>
                                <h5 class="card-dados" v-else>Sem registro</h5>
                            </div>
                            <div class="col">
                                <label class="form-label"> Cláusula Reajuste</label>
                                <h5 class="card-dados" v-if="dados.nrClausulaReajuste != null">
                                    {{ dados.nrClausulaReajuste }}
                                </h5>
                                <h5 class="card-dados" v-else>Sem registro</h5>
                            </div>

                        </div>
                        <div class="col-11 card-line"></div>
                        <div class="row mt-3">
                            <div class="col">
                                <label class="form-label"> Observações</label>
                                <h5 class="card-dados" v-if="dados.dsObservacao != null">{{ dados.dsObservacao }}</h5>
                                <h5 class="card-dados" v-else>Sem registro</h5>
                            </div>
                        </div>

                    </template>
                </Card_Title>

            </div>

            <div class="col-6" v-if="dados.idContrato > 0">

                <label class="form-label" style="color: #AB0000"> Arquivos</label>
                <Card_Title :class_color="'bg-color-4'" :customSize="'min-height: 296px'">
                    <template v-slot:context>

                        <label class="form-label" v-if="dados.nmSupervisorContrato != null">
                            Supervisor:
                            {{ dados.nmSupervisorContrato }}
                        </label>
                        <label class="form-label" v-else> Supervisor: nenhum supervisor cadastrado...</label>

                        <div class="row mt-3">
                            <div class="col">
                                <button type="button" class="btn btn-white-v3" style="width: 100%"
                                        v-if="dados.urlCartaoCnpj == null || dados.urlCartaoCnpj == '' || dados.urlCartaoCnpj == '/Np/Plataforma/'"
                                        disabled>
                                    Ver Cartão CNPJ
                                </button>
                                <button type="button" class="btn btn-white-v3" style="width: 100%"
                                        v-on:click="openURL(dados.urlCartaoCnpj)" v-else>
                                    Ver Cartão CNPJ
                                </button>
                            </div>
                            <div class="col">
                                <button type="button" class="btn btn-white-v3" style="width: 100%"
                                        v-if="dados.urlAutorizacao == null || dados.urlAutorizacao == '' || dados.urlAutorizacao == '/Np/Plataforma/'"
                                        disabled>
                                    Ver Autorização
                                </button>
                                <button type="button" class="btn btn-white-v3" style="width: 100%"
                                        v-on:click="openURL(dados.urlAutorizacao)" v-else>
                                    Ver Autorização
                                </button>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col">
                                <button type="button" class="btn btn-white-v3" style="width: 100%"
                                        v-if="dados.urlProposta == null || dados.urlProposta == '' || dados.urlProposta == '/Np/Plataforma/'"
                                        disabled>
                                    Ver Proposta
                                </button>
                                <button type="button" class="btn btn-white-v3" style="width: 100%"
                                        v-on:click="openURL(dados.urlProposta)" v-else>
                                    Ver Proposta
                                </button>
                            </div>
                            <div class="col">
                                <button type="button" class="btn btn-white-v3" style="width: 100%"
                                        v-if="dados.urlEmpenho == null || dados.urlEmpenho == '' || dados.urlEmpenho == '/Np/Plataforma/'"
                                        disabled>
                                    Ver Emp Comercial
                                </button>
                                <button type="button" class="btn btn-white-v3" style="width: 100%"
                                        v-on:click="openURL(dados.urlEmpenho)" v-else>
                                    Ver Emp Comercial
                                </button>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col">
                                <button type="button" class="btn btn-white-v3" style="width: 100%"
                                        v-if="dados.urlArquivoContratoProvisorio == null || dados.urlArquivoContratoProvisorio == '' || dados.urlArquivoContratoProvisorio == '/Np/Plataforma/'"
                                        disabled>
                                    Ver Contrato Prov
                                </button>
                                <button type="button" class="btn btn-white-v3" style="width: 100%"
                                        v-on:click="openURL(dados.urlArquivoContratoProvisorio)" v-else>
                                    Ver Contrato
                                    Prov
                                </button>
                            </div>
                            <div class="col">
                                <button type="button" class="btn btn-white-v3" style="width: 100%"
                                        v-if="dados.urlArquivoContrato == null || dados.urlArquivoContrato == '' || dados.urlArquivoContrato == '/Np/Plataforma/'"
                                        disabled>
                                    Ver Contrato
                                </button>
                                <button type="button" class="btn btn-white-v3" style="width: 100%"
                                        v-on:click="openURL(dados.urlArquivoContrato)" v-else>
                                    Ver Contrato
                                </button>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col">
                                <button type="button" class="btn btn-white-v3" style="width: 100%"
                                        v-if="dados.urlEmpenhoAdm == null || dados.urlEmpenhoAdm == '' || dados.urlEmpenhoAdm == '/Np/Plataforma/'"
                                        disabled>
                                    Ver Empenho Adm
                                </button>
                                <button type="button" class="btn btn-white-v3" style="width: 100%"
                                        v-on:click="openURL(dados.urlEmpenhoAdm)" v-else>
                                    Ver Empenho Adm
                                </button>
                            </div>
                            <div class="col">
                                <button type="button" class="btn btn-white-v3" style="width: 100%"
                                        v-if="dados.urlNotaFiscal == null || dados.urlNotaFiscal == '' || dados.urlNotaFiscal == '/Np/Plataforma/'"
                                        disabled>
                                    Ver Nota Fiscal
                                </button>
                                <button type="button" class="btn btn-white-v3" style="width: 100%"
                                        v-on:click="openURL(dados.urlNotaFiscal)" v-else>
                                    Ver Nota Fiscal
                                </button>
                            </div>
                        </div>

                    </template>
                </Card_Title>
            </div>
        </div>

        <div class="row mt-3" v-if="ocorrencia.idInstituicao > 0">
            <div class="col">
                <div :class="'card mt-1 p-0 mb-2 shadow-v2'" style="border-radius: 5px 5px 0px 5px;">
                    <div class="row g-0 box-info">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <div class="row">
                                        <div class="row">
                                            <div class="col">
                                                <label class="form-label" style="color: #AB0000">Contratos</label>                                                
                                            </div>
                                        </div>
                                    </div>
                                    <DataTable :url_ajax="getUrlContratos()" :ajax_set_result="setTableContratos"
                                               @grid_refreshed="gridRefreshed_contratos" :refresh="refresh_grid_contratos" :filtros="filtro"
                                               method="GET" :qtd_registros_por_pagina="20" :is_table="true" :footer_fixed="false"
                                               customHeight="margin-top: 0px !important;max-height: calc(100vh - 30rem);"
                                               :headers="headersContratos" :pBtnsSlot="true"
                                               :borderColor="getBackgroundColor(cdSetorClassificacaoEtapa)" :request_api="'comercial'">
                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="row mt-3" v-if="dados.idEmpresa > 0">
            <div class="col">
                <div :class="'card mt-1 p-0 mb-2 shadow-v2'" style="border-radius: 5px 5px 0px 5px;">
                    <div class="row g-0 box-info">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <div class="row">
                                        <div class="row">
                                            <div class="col">
                                                <label class="form-label" style="color: #AB0000">Empresas</label>
                                                <h5 class="card-dados">
                                                    {{ dados.nmRazaoSocialEmpresa }}
                                                </h5>
                                            </div>
                                            <div class="col">
                                                <label class="form-label" style="color: #AB0000">Cnpj</label>
                                                <h5 class="card-dados">
                                                    {{ dados.nrCnpj }}
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                    <DataTable :url_ajax="getUrlUnidadesDeCompra()" :ajax_set_result="setTableUnidadesDeCompra"
                                               @grid_refreshed="gridRefreshed" :refresh="refresh_grid_unidades" :filtros="filtro"
                                               method="GET" :qtd_registros_por_pagina="20" :is_table="true" :footer_fixed="false"
                                               customHeight="margin-top: 0px !important;max-height: calc(100vh - 30rem);"
                                               :headers="headersUnidades" :pBtnsSlot="true"
                                               :borderColor="getBackgroundColor(cdSetorClassificacaoEtapa)" :request_api="'comercial'">
                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <InstituicaoPessoas :p_exibir="openModalPessoasTicket" :p_idOcorrencia="idOcorrencia" :p_idInstituicao="idInstituicao" :idModulo="ocorrencia.idModulo" @fecharModal="fecharModal"></InstituicaoPessoas>

    </div>
</template>

<script>

    import axios from 'axios';
    import DataTable from '@/components/App/Datatable.vue'
    import OcorrenciaInfo from '@/components/Tickets/Ocorrencia/Ocorrencia_Info.vue'
    import Card_Title from '@/components/App/Card_Title.vue';
    import InstituicaoPessoas from "@/views/Modais/InstituicaoPessoas.vue";

    export default {
        name: 'Dados Cliente',
        components: {
            DataTable,
            OcorrenciaInfo,
            Card_Title,
            InstituicaoPessoas
        },
        props: {
            idOcorrencia: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                openModalPessoasTicket: false,

                ocorrencia: {},
                chamado: {},
                setor: {},

                NotLoading: false,
                dados: { cdInstituicao: 0, nrMesesCliente: 0 },
                produtos_eventos: {},
                cdSetorClassificacaoEtapa: 0,

                refresh_grid: false,
                refresh_grid_EventosInstituicao: false,
                refresh_grid_EventosInstituicaoAno: false,
                refresh_grid_ProdutosInstituicao: false,
                refresh_grid_EventosPessoa: false,
                refresh_grid_ProdutosPessoa: false,
                refresh_grid_unidades: false,
                refresh_grid_contratos: false,

                filtro: [
                    { active: true },
                ],


                headersEventosInstituicao: [
                    { class: '', name: 'nmEvento', text: 'Eventos que participou', order: 0 },
                ],
                headersEventosInstituicaoAno: [
                    { class: '', name: 'nmEvento', text: 'Eventos que participou em ', order: 0 },
                ],
                headersProdutosInstituicao: [
                    { class: '', name: 'nmModulo', text: 'Produtos Contratados', order: 0 },
                ],
                headersEventosPessoa: [
                    { class: '', name: 'nmEvento', text: 'Eventos que participou', order: 0 },
                ],
                headersProdutosPessoa: [
                    { class: '', name: 'nmModulo', text: 'Produtos Contratados', order: 0 },
                ],
                headersHistorico: [
                    { class: '', name: 'cdInstituicao', text: 'Histórico de chamados', order: 0 },
                    { class: '', name: 'nmRazaoSocial', text: '', order: 0 },
                    { class: '', name: 'dtInclusaoString', text: '', order: 0 },
                    { class: '', name: 'nmUsuario', text: '', order: 0 }
                ],
                headersUnidades: [],
                headersContratos: [
                    { class: 'col', name: 'nrContrato', text: 'Nr. / Ano', order: 0 },
                    { class: 'col', name: 'nmModulo', text: 'Produto', order: 0 },
                    { class: 'col', name: 'nmPlano', text: 'Versão', order: 0 },
                    { class: 'col-1 max_w_120', name: 'flAtivoHtml', text: 'Ativo', order: 0 },
                    { class: 'col-1', name: 'dtInicio', text: 'Início', order: 0 },
                    { class: 'col-1', name: 'dtFim', text: 'Fim', order: 0 },
                    { class: 'col-1 max_w_120', name: 'qtdLicencas', text: 'Licenças', order: 0 },
                    { class: 'col-1 max_w_120', name: 'qtdUsuarios', text: 'Usuários', order: 0 },
                ],

                idInstituicao: 0,
                inadimplente: ''
            }
        },
        mounted() {
            this.getOcorrencia();
            this.headersEventosInstituicaoAno = [{ class: '', name: 'nmEvento', text: 'Eventos que participou em ' + this.ano_atual, order: 0 }];
        },
        methods: {
            getUrlContratos() {
                let $this = this;
                return process.env.VUE_APP_ROOT_COMERCIAL_API + '/Contrato/GetContratosOcorrencia?idOcorrencia=' + $this.idOcorrencia;
            },
            setTableContratos(result) {
                result.forEach((value, index) => {
                    value.nrContrato = value.nrContrato + ' / ' + value.nrAno;
                    if (value.flAtivo == "Sim") {
                        value.flAtivoHtml = '<i class="fas fa-check icon-grid-lista-check ps-2" style="color: #34A853"></i>';
                    }
                    else {
                        value.flAtivoHtml = '<i class="fas fa-times icon-grid-lista-uncheck ps-2" style="color: #9F3029"></i>';
                    }
                })
                return result;
            },
            fecharModal(_param) {
                this.openModalPessoasTicket = false;
            },
            openModalPessoas() {
                this.openModalPessoasTicket = true;
            },
            openURL(url) {
                let $this = this;
                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Amazon/GetDownload?url=' + url, {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    window.open(response.data.data, "_blank");
                })
            },
            formatPrice(value) {
                let val = (value / 1).toFixed(2).replace('.', ',')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            },
            getBackgroundColor(cdSetorClassificacaoEtapa) {
                switch (cdSetorClassificacaoEtapa) {
                    case 1:
                        return '#FF8A00';
                    case 2:
                        return '#0047FF';
                    case 3:
                        return '#00AB11';
                    case 4:
                        return '#AB0000';
                    default:
                        return '#ffc107';
                }
            },
            getUrlEventosInstituicao() {
                let $this = this;
                return process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetOcorrenciaEventosInstituicao?idOcorrencia=' + $this.idOcorrencia;
            },
            getUrlEventosInstituicaoAno() {
                let $this = this;
                return process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetOcorrenciaEventosInstituicaoAno?idOcorrencia=' + $this.idOcorrencia;
            },
            getUrlProdutosInstituicao() {
                let $this = this;
                return process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetOcorrenciaProdutosInstituicao?idOcorrencia=' + $this.idOcorrencia;
            },
            setTable(result) {
                return result;
            },
            setTableUnidadesDeCompra(result) {
                result.forEach((value, index) => {
                    if (value.flAtivo == "Sim") {
                        value.flAtivoHtml = '<i class="fas fa-check icon-grid-lista-check ps-2" style="color: #34A853"></i>';
                    }
                    else {
                        value.flAtivoHtml = '<i class="fas fa-times icon-grid-lista-uncheck ps-2" style="color: #9F3029"></i>';
                    }

                    if (value.flClienteModulo) {
                        value.flClienteModuloHtml = '<i class="fas fa-check icon-grid-lista-check ps-2" style="color: #34A853"></i>';
                    }
                    else {
                        value.flClienteModuloHtml = '<i class="fas fa-times icon-grid-lista-uncheck ps-2" style="color: #9F3029"></i>';
                    }

                    if (value.flTemEvento) {
                        value.flTemEventoHtml = '<i class="fas fa-check icon-grid-lista-check ps-2" style="color: #34A853"></i>';
                    }
                    else {
                        value.flTemEventoHtml = '<i class="fas fa-times icon-grid-lista-uncheck ps-2" style="color: #9F3029"></i>';
                    }
                    if (value.flTemEventoAno) {
                        value.flTemEventoAnoHtml = '<i class="fas fa-check icon-grid-lista-check ps-2" style="color: #34A853"></i>';
                    }
                    else {
                        value.flTemEventoAnoHtml = '<i class="fas fa-times icon-grid-lista-uncheck ps-2" style="color: #9F3029"></i>';
                    }
                    if (value.flTemEventoSelecionado) {
                        value.flTemEventoSelecionadoHtml = '<i class="fas fa-check icon-grid-lista-check ps-2" style="color: #34A853"></i>';
                    }
                    else {
                        value.flTemEventoSelecionadoHtml = '<i class="fas fa-times icon-grid-lista-uncheck ps-2" style="color: #9F3029"></i>';
                    }

                    if (value.flPendenciaFinanceira) {
                        value.flPendenciaFinanceiraHtml = '<i class="fas fa-check icon-grid-lista-check ps-2" style="color: #34A853"></i>';
                    }
                    else {
                        value.flPendenciaFinanceiraHtml = '<i class="fas fa-times icon-grid-lista-uncheck ps-2" style="color: #9F3029"></i>';
                    }
                })
                return result;
            },
            getUrlEventosPessoa() {
                let $this = this;
                return process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetOcorrenciaEventosPessoa?idOcorrencia=' + $this.idOcorrencia;
            },
            getUrlProdutosPessoa() {
                let $this = this;
                return process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetOcorrenciaProdutosPessoa?idOcorrencia=' + $this.idOcorrencia;
            },
            gridRefreshed(data_ajax) {
                let $this = this;

                $this.refresh_grid = false;
                $this.refresh_grid_EventosInstituicao = false;
                $this.refresh_grid_EventosInstituicaoAno = false;
                $this.refresh_grid_ProdutosInstituicao = false;
                $this.refresh_grid_EventosPessoa = false;
                $this.refresh_grid_ProdutosPessoa = false;
                $this.refresh_grid_unidades = false;
                $this.refresh_grid_contratos = false;
            },
            gridRefreshed_contratos(data_ajax) {
                let $this = this;

                $this.refresh_grid_contratos = false;
            },
            reloadGrid() {
                let $this = this;

                $this.refresh_grid = true;
                $this.refresh_grid_EventosInstituicao = true;
                $this.refresh_grid_EventosInstituicaoAno = true;
                $this.refresh_grid_ProdutosInstituicao = true;
                $this.refresh_grid_EventosPessoa = true;
                $this.refresh_grid_ProdutosPessoa = true;
                $this.refresh_grid_unidades = true;
                $this.refresh_grid_contratos = true;
            },
            getOcorrencia() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetId?id=' + $this.idOcorrencia, {
                    headers: $this.$api.getTokenComercial(),
                    params: '',
                    notLoading: true
                }).then(response => {
                    $this.ocorrencia = response.data.data;
                    if ($this.ocorrencia.idChamado > 0) {
                        $this.getDadosChamado();
                    }
                    if ($this.ocorrencia.idEvento > 0) {
                        $this.headersUnidades = [
                            { class: 'col max_w_200', name: 'cdInstituicao', text: 'Nº da Unidade', order: 0 },
                            { class: 'col', name: 'nmRazaoSocial', text: 'Razão Social', order: 0 },
                            { class: 'col max_w_200', name: 'flTemEventoHtml', text: 'Evento', order: 0 },
                            { class: 'col max_w_200', name: 'flTemEventoAnoHtml', text: 'Evento Ano', order: 0 },
                            { class: 'col max_w_200', name: 'flTemEventoSelecionadoHtml', text: 'Evento Selecionado', order: 0 },
                            { class: 'col max_w_200', name: 'flAtivoHtml', text: 'Unidade Ativa', order: 0 },
                        ];
                    }
                    else {
                        $this.headersUnidades = [
                            { class: 'col max_w_200', name: 'cdInstituicao', text: 'Nº da Unidade', order: 0 },
                            { class: 'col', name: 'nmRazaoSocial', text: 'Razão Social', order: 0 },
                            { class: 'col max_w_200', name: 'flClienteModuloHtml', text: 'Cliente do Produto', order: 0 },
                            { class: 'col max_w_200', name: 'flAtivoHtml', text: 'Unidade Ativa', order: 0 },
                            { class: 'col max_w_200', name: 'flPendenciaFinanceiraHtml', text: 'Pendência Financeira', order: 0 },
                        ];
                    }
                    $this.getCdSetorClassificacaoEtapa();
                    $this.idInstituicao = $this.ocorrencia.idInstituicao;
                    $this.getSetor($this.idOcorrencia);
                    $this.getDadosOcorrencia();
                })
            },
            getDadosOcorrencia() {
                let $this = this;
                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetDadosOcorrencia?idOcorrencia=' + $this.idOcorrencia, {
                    headers: $this.$api.getTokenComercial(),
                    notLoading: true
                }).then(response => {
                    $this.dados = response.data.data;
                    $this.reloadGrid();
                    $this.GetInadimplente();
                })
            },
            GetInadimplente() {
                let $this = this;
                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Instituicao/GetInadimplente?idInstituicao=' + $this.ocorrencia.idInstituicao + '&idModulo=' + $this.ocorrencia.idModulo, {
                    headers: $this.$api.getTokenComercial(),
                    notLoading: true
                }).then(response => {
                    $this.inadimplente = response.data.data;
                })
            },
            getSetor(idOcorrencia) {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Setor/GetByIdOcorrencia?idOcorrencia=' + idOcorrencia, {
                    headers: $this.$api.getTokenComercial(),
                    params: '',
                    notLoading: true
                }).then(response => {
                    $this.setor = response.data.data;
                })
            },
            getCdSetorClassificacaoEtapa() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/SetorClassificacaoEtapa/GetCdSetorClassificacaoEtapa?idSetorClassificacaoEtapa=' + $this.ocorrencia.idSetorClassificacaoEtapaAtual, {
                    headers: $this.$api.getTokenComercial(),
                    params: '',
                    notLoading: true
                }).then(response => {
                    $this.cdSetorClassificacaoEtapa = response.data.data;
                })
            },
            GetProdutosEventosProdutoNP() {
                let $this = this;
                //axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Cliente/GetProdutosEventosProdutoNP?idInstituicao=' + $this.dados.idInstituicao + '&idPessoa=' + $this.dados.idPessoa, {
                //    headers: $this.$api.getTokenComercial(),
                //    params: ''
                //}).then(response => {
                //    $this.produtos_eventos = response.data.data;
                //})
            },
            setActionCard(action) {
                this.$emit('setActionCard', action);
            },
            getDadosChamado() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Chamado/Get?id=' + $this.ocorrencia.idChamado, {
                    headers: $this.$api.getTokenComercial(),
                    params: '',
                    notLoading: true
                }).then(response => {
                    $this.chamado = response.data.data;
                })
            },
            getUrlUnidadesDeCompra() {
                let $this = this;
                var url = process.env.VUE_APP_ROOT_COMERCIAL_API + '/CnpEmpresa/GetInstituicoes?idEmpresa=' + $this.dados.idEmpresa + '&idModulo=' + $this.ocorrencia.idModulo + '&idEvento=' + ($this.ocorrencia.idEvento > 0 ? $this.ocorrencia.idEvento : '0');
                return url;
            },
        },
        computed: {
            ano_atual() {
                return new Date().getFullYear();
            },
        },
        watch: {
            idOcorrencia(newVal, oldVal) {
                this.getOcorrencia(newVal);
            },
            cdSetorClassificacaoEtapa(newValue) { },
        },
    }

</script>

<style scoped lang="scss">
    .spanSeeMore {
        &:hover {
            text-decoration: underline;
        }
    }

    .pessoa-ticket {
        font-weight: bold;
    }

    .canvas-v2 {
        border-radius: 5px;
        padding: 10px;
    }

    .card-dados {
        font-size: 14px;
        /*cursor: pointer;*/
    }

    .cart-title-span {
        font-weight: bold;
        margin-left: 5px;
    }

    .card-idt {
        height: 5px;
        border-bottom: 1px solid #BBBBBB;
        margin-top: 10px;
        left: 15%;
        position: absolute
    }

    .card-line {
        height: 5px;
        border-bottom: 1px solid #BBBBBB;
        /*margin-top: 10px;*/
        position: absolute
    }

    .card-cont {
        height: 5px;
        border-bottom: 1px solid #BBBBBB;
        margin-top: 10px;
        left: 11%;
        position: absolute;
        min-width: 87.4%;
    }

    .canvas-v2-header {
        border-radius: 5px;
        height: 63px;
        line-height: 50px;
        padding-left: 5px;
        box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.05);
        margin-bottom: 10px;
    }

    .bg-color-4 {
        background-color: #AB0000;
    }

    .row-dados {
        padding: 30px;
    }

    .accordion-button:not(.collapsed) {
        background-color: #9f3129ad;
        color: black
    }

    .box-dados {
        min-height: 200px;
        font-size: 11px;
    }

    .box-info {
        min-height: 150px;
        font-size: 14px;
    }



    .card-text-sim {
        font-weight: bold;
        margin-left: 5px;
        font-size: 18px;
        color: #00AB11;
    }

    .card-text-nao {
        font-weight: bold;
        margin-left: 5px;
        font-size: 18px;
        color: #AB0000;
    }

    .card-text-neutro {
        float: right;
        font-weight: bold;
        margin-left: 5px;
        font-size: 18px;
        color: #F4F4F4;
    }


    .line-card {
        border-radius: 10px 0px 0px 10px;
        max-width: 10px;
        margin-left: -3px;
        margin-top: -1px;
        margin-bottom: -2px;
    }

    .canvas {
        max-width: 600px;
        margin: 0 auto;
    }


    .btn-white-v3 {
        background: white;
        box-shadow: 0px 0px 4px 0px #00000040;
        /*border-radius: 5px 5px 5px 40px;*/
        min-height: 40px;
        padding: 0 35px 3px 35px;
        color: #9F3029;
        font-weight: 500;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #9F3029;
    }

    .btn-white-v3:hover {
        color: white;
        background: #9F3029 !important;
        border: 1px solid #9F3029 !important;
    }

    @media screen and (max-width:1400px) {
        .card-cont {
            left: 15%;
            min-width: unset;
        }
    }

    .txt-alert-pendencia {
        font-weight: bold;
        margin-left: 10px;
    }

    .star-avaliacao {
        color: #9F3029;
        font-size: 12px;
    }

</style>